import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import NewModelFormFields from './NewModelFormFields';


const NewModelForm = ({
  initialValues,
  onSubmit,
  showFileInput = true,
  handleCloseModal,
  FieldsComponent = NewModelFormFields,
  showTestImages = true,
  testImagesRequired = true,
  existingTestImages = [],
  title = 'New Model Info',
  submitLabel = 'Import',
}) => {
  const [modelInfoForm, setModelInfoForm] = useState(initialValues);


  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    
    let finalValue;
    if (type === "file") {
      finalValue = e.target.files[0];
    } else if (type === "file-multi") {
      finalValue = value; // already an array of files from onChange above
    } else if (type === "checkbox") {
      finalValue = checked;
    } else {
      finalValue = value;
    }

    const keys = name.split(".");
    setModelInfoForm((prev) => {
      const updated = { ...prev };
      let nested = updated;
      for (let i = 0; i < keys.length - 1; i++) {
        nested[keys[i]] = { ...nested[keys[i]] };
        nested = nested[keys[i]];
      }
      nested[keys[keys.length - 1]] = finalValue;
      return updated;
    });
  };

  const handleSubmit = async () => {

    const updatedForm = {
      ...modelInfoForm
    };

    await onSubmit(updatedForm);
    setModelInfoForm(updatedForm);
  };


  return (
    <>
      {/* <NewModelFormFields form={modelInfoForm} handleChange={handleChange} width="95%" /> */}
      <FieldsComponent
        form={modelInfoForm}
        handleChange={handleChange}
        showFileInput={showFileInput}
        showTestImages={showTestImages}
        testImagesRequired={testImagesRequired}
        existingTestImages={existingTestImages}
        title={title}
        width="95%"
      />

      <Box sx={{ padding: 2, width: '50%', mx: 'auto', mt: 1, display: 'flex', justifyContent: 'center', gap: 4 }}>
        <Button
          variant="outlined"
          onClick={handleCloseModal}
          sx={{ borderRadius: '12px', textTransform: 'none', fontSize: '16px', width: '120px', color: '#16a4b0', borderColor: '#16a4b0', '&:hover': { backgroundColor: '#f0f0f0', borderColor: '#16a4b0' } }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{ borderRadius: '12px', backgroundColor: '#16a4b0', color: 'white', textTransform: 'none', fontSize: '16px', width: '120px', '&:hover': { backgroundColor: '#00707c' } }}
        >
          {submitLabel}
        </Button>
      </Box>
    </>
  );
};
 
export default NewModelForm;
